export default "__VITE_ASSET__BnCKfZt0__"